import React, { memo } from 'react';

interface SearchResultsHeaderProps {
    totalResults: number;
    currentPage: number;
    pageSize: number;
    resultsLength: number;
    sortBy: string;
    onSortChange: (sortBy: string) => void;
}

export const SearchResultsHeader: React.FC<SearchResultsHeaderProps> = memo(({
    totalResults,
    currentPage,
    pageSize,
    resultsLength,
    sortBy,
    onSortChange
}) => {

    // Calculate the range of results being displayed
    const getResultRange = () => {
        if (totalResults === 0) {
            return { start: 0, end: 0, isZeroResults: true };
        }
        
        if (resultsLength === 0) {
            return null;
        }
        
        const start = (currentPage - 1) * pageSize + 1;
        const end = Math.min(start + resultsLength - 1, totalResults);
        
        return { start, end, isZeroResults: false };
    };

    const range = getResultRange();

    if (!range) 
        return null;

    const { start, end, isZeroResults } = range;
    const formattedTotal = totalResults.toLocaleString();

    let resultsText;

    if (isZeroResults) {
        resultsText = `(Showing 0 results)`;
    } else if (totalResults === 1) {
        resultsText = `(Showing 1 result)`;
    } else if (start === end) {
        resultsText = `(Showing ${start.toLocaleString()} of ${formattedTotal} results)`;
    } else {
        resultsText = `(Showing ${start.toLocaleString()}-${end.toLocaleString()} of ${formattedTotal} results)`;
    }

    return (
        <div className='search-page-results-header'>
            <p>{resultsText}</p>            
            
            <div className='search-page-results-sort'>
                <label htmlFor="sort-by">
                    Sort by: 
                </label>
                <select 
                    id="sort-by" 
                    value={sortBy} 
                    onChange={(e) => onSortChange(e.target.value)}
                >
                    <option value="relevance">Relevance</option>
                    <option value="newest">Newest</option>
                    <option value="oldest">Oldest</option>
                </select>
            </div>
        </div>
    );
});

SearchResultsHeader.displayName = 'SearchResultsHeader';
